"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyIcon = void 0;
const react_1 = __importDefault(require("react"));
const VerifyIcon = () => (react_1.default.createElement("svg", { viewBox: "0 0 16 16" },
    react_1.default.createElement("path", { fill: "none", d: "M0 0h16v16H0z" }),
    react_1.default.createElement("path", { fill: "#54b948", d: "M15 5.48L12.519 3 7.496 8.024 4.481 5.009 2 7.49l5.493 5.493.003-.003.003.003z" }),
    react_1.default.createElement("path", { fill: "#54b948", d: "M1 2h13V1H0v14h14V9h-1v5H1z" })));
exports.VerifyIcon = VerifyIcon;
//# sourceMappingURL=VerifyIcon.js.map